import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Panel, SectionTitle, TactLoader } from "../components/Tactical";

export default function ChatList() {
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/dm/threads");
        if (alive) setThreads(data);
      } catch (e) { /* noop */ }
      finally { if (alive) setLoading(false); }
    };
    load();
    const iv = setInterval(load, 10000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  return (
    <div data-testid="chat-list-page" className="space-y-4">
      <SectionTitle kicker="// direct messages" testId="chat-list-title">Player Chats</SectionTitle>
      {loading ? <TactLoader /> : threads.length === 0 ? (
        <Panel className="font-mono text-[#71717A] text-sm">[ NO PLAYERS TO CHAT WITH YET — wait until your league fills up. ]</Panel>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="chat-threads">
          {threads.map((t) => (
            <Link key={t.user.id} to={`/chat/${t.user.id}`} className="bg-[#FFFFFF] dark:bg-[#1A1A1E] border border-[#E4E4E7] dark:border-[#2A2A30] p-4 hover:border-[#7C3AED] transition-colors block" data-testid={`thread-${t.user.id}`}>
              <div className="flex items-center justify-between mb-1">
                <div className="font-heading text-lg uppercase truncate">{t.user.username}</div>
                {t.unread > 0 && (
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] bg-[#E11D48] text-[#09090B] dark:text-[#F4F4F5] px-2 py-0.5" data-testid={`unread-${t.user.id}`}>
                    {t.unread}
                  </span>
                )}
              </div>
              <div className="font-mono text-[10px] text-[#71717A] truncate">
                {t.last_message
                  ? `${t.last_message.text.slice(0, 80)}${t.last_message.text.length > 80 ? "…" : ""}`
                  : "[ NO MESSAGES YET ]"}
              </div>
              {t.last_message && (
                <div className="font-mono text-[9px] text-[#71717A] tracking-[0.2em] mt-1">
                  {new Date(t.last_message.created_at).toLocaleString()}
                </div>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
